export enum DealStage {
  WON = 'dealStageWon',
  PENDING = 'dealStagePending',
  LOST = 'dealStageLost',
}
